import { TYPES } from "../actions";
import { setToken } from "../utils/token";

const initialState = {
  authenInfo: {},
  isLoggedIn: false,
  user: null,
  error: null
};

export const authenReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ACTION_LOGIN_SUCCESS:
      setToken(action.payload.token);

      return { ...state, 
        isLoggedIn: true, 
        token: action.payload.token,
        user: action.payload.user,
        error: null // Clear error on success
      };

    case TYPES.ACTION_GET_USER_SUCCESS:
      return { ...state, 
        isLoggedIn: true,
        user: action.payload.user 
      };

    case TYPES.ACTION_CHANGE_PASSWORD_SUCCESS:
      return { ...state, 
        user: action.payload.user 
      };

    case TYPES.ACTION_LOGIN_FAIL:
      return { ...state, 
        isLoggedIn: false, 
        token: "",
        error: action.payload?.error || "Login failed"
      };
      
    default:
      return state;
  }
};
